import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

const slides = ["bg1", "bg3", "bg4", "bg5"];

function HeroSlide({ bgClass }) {
  return (
    <div>
      <div className={`${bgClass} pt-100 pt-30-m`}>
        <div className="container ">
          <div className="slidersection pt-100 pt-30-m">
            <h1>Join the <br/> Community</h1>
            <p><span className="slider-tagline">A community that moves you</span> Bring your automotive passion to life with exclusive benefits, rewards, free or discounted experiences, and Ride24—your way to discover, create and join rides with fellow enthusiasts.</p>

            <div className="slidersub ">
              <ul>
                <li><Link className="btn-primary" to="/Plans"> Join Now</Link> </li>
                <li><a  href="/Offers"> Explore Rewards <i className="fa-solid fa-arrow-right"></i> </a> </li>
              </ul>
            </div>

            <div className="sliderlist  ">
              <ul>
                <li><i className="fa-solid fa-check"></i>  Get 1-day free trial</li>
                <li><i className="fa-solid fa-check"></i>  Exclusive Offers  </li>
                <li><i className="fa-solid fa-check"></i>  Cancel anytime  </li>
                <li><i className="fa-solid fa-check"></i>  Full Refund - Change of mind in 24 hrs </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function SimpleSlider() {
  var settings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="container-fluid bg bg-black fallback-old-style">
      <Slider {...settings}>
        {slides.map((bgClass) => (
          <HeroSlide key={bgClass} bgClass={bgClass} />
        ))}
      </Slider>
    </div>
  );
}
